import { CheckboxGroup, CheckboxGroupProps } from '@components/checkbox-group';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormCheckboxGroupProps<T = unknown> = FormFieldProps<CheckboxGroupProps, T>;

export function FormCheckboxGroup<T>(props: FormCheckboxGroupProps<T>) {
  const formFieldProps = useFormField(props);

  return <CheckboxGroup {...props} {...formFieldProps} />;
}
